import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { SearchAutocompleteComponent } from '@shared/ui';

@Component({
  selector: 'app-search',
  imports: [MatIconModule],
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent extends SearchAutocompleteComponent {
  private router = inject(Router);

  constructor() {
    super();
  }

  routeSearchResults(location: string) {
    this.router.navigate(['/search-results'], {
      state: { location },
    });
  }
}
